<template>
  <div class="info">
		<div class="info-container">
      <h1>
        <p>侦查结果已呈送“巢人侦探所”进行判断</p>
      </h1>   
      <!--查看结果-->
      <div class="check-container">
        <div class="check-wrapper"
             v-on:click="checkResult">
          <div class="check-btn">查看侦查结果</div>
        </div>
      </div>

      <img v-bind:src="bgSrc" style="display:none;"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "info",
  data () {
    return {
      bgSrc: require("@/pages/result/images/bg.jpg"),     
    }  
  },
  computed: {
  },
  methods: {
    checkResult () {
      this.$router.push("/result");
    }
  },
}
</script>

<style lang="scss" scoped>
@import "./info.scss";
</style>



// WEBPACK FOOTER //
// src/pages/info/info.vue